import styled from 'styled-components';

export const StyledOutputWrapper = styled.div`
  align-items: flex-start;
  display: grid;
  grid-template-columns: [hint-start result-start] 100% [result-end hint-end];
  grid-template-rows: [hint-start result-start] 100% [result-end hint-end];
`;
